"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabUnderlineStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _tabConstants = require("./tabConstants");
var _tabsTheme = require("./tabsTheme");
const TabUnderlineStyled = (0, _styled.default)("div")`
    position: absolute;
    bottom: 0;
    left: ${_ref => {
  let {
    leftPx
  } = _ref;
  return leftPx;
}}px;
    width: ${_ref2 => {
  let {
    widthPlusUnit
  } = _ref2;
  return widthPlusUnit;
}};
    height: ${_ref3 => {
  let {
    height = "2px"
  } = _ref3;
  return height;
}};
    background-color: ${_ref4 => {
  let {
    backgroundColor
  } = _ref4;
  return backgroundColor;
}};

    ${_ref5 => {
  let {
    underlineTransition,
    themeMode
  } = _ref5;
  if (underlineTransition) {
    return `transition: width ${_tabConstants.transitionDurationSeconds}s ${_tabsTheme.tabsTheme.underlineAnimation(themeMode)}, left ${_tabConstants.transitionDurationSeconds}s ${_tabsTheme.tabsTheme.underlineAnimation(themeMode)};`;
  }
}}
`;
exports.TabUnderlineStyled = TabUnderlineStyled;
TabUnderlineStyled.displayName = "TabUnderlineStyled";
//# sourceMappingURL=TabUnderlineStyled.js.map